import { Temporal } from 'temporal-polyfill';

import { InstantInterval } from './instant-interval.js';

export type PlainDateTimeInitializer = Temporal.PlainDateTime | Temporal.PlainDateTimeLike | string;

export class PlainDateTimeInterval {
  static from(start: PlainDateTimeInitializer, end: PlainDateTimeInitializer): PlainDateTimeInterval {
    return new this(Temporal.PlainDateTime.from(start), Temporal.PlainDateTime.from(end));
  }

  constructor(
    public start: Temporal.PlainDateTime,
    public end: Temporal.PlainDateTime,
  ) {
    validatePlainDateTimeIntervalLike(start, end);
  }

  toString(): string {
    return `${this.start.toString()}/${this.end.toString()}`;
  }

  toInstantInterval(timeZone: Temporal.TimeZoneLike): InstantInterval {
    const start = this.start.toZonedDateTime(timeZone).toInstant();
    const end = this.end.toZonedDateTime(timeZone).toInstant();
    return InstantInterval.from(start, end);
  }
}

export function validatePlainDateTimeIntervalLike(start: Temporal.PlainDateTime, end: Temporal.PlainDateTime) {
  if (Temporal.PlainDateTime.compare(start, end) > 0) {
    throw new RangeError("A PlainTimeInterval's start must occur before the end");
  }
}
